(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function() {
  // Save the last page visited (excluding cart and checkout pages)
  if (!window.location.pathname.includes('/cart') && 
      !window.location.pathname.includes('/checkout')) {
    sessionStorage.setItem('lastVisitedPage', window.location.href);
  }
  
  // If we arrived at cart from a product page, save the collection URL if exists
  if (window.location.pathname.includes('/cart') && 
      document.referrer && 
      document.referrer.includes('/products/') &&
      document.referrer.includes(window.location.hostname)) {
    
    // Check if the product URL contains a collection path
    const collectionMatch = document.referrer.match(/\/collections\/([^\/]+)\/products/);
    
    if (collectionMatch && collectionMatch[1]) {
      // Save the collection URL instead of the product page
      const collectionUrl = window.location.origin + '/collections/' + collectionMatch[1];
      sessionStorage.setItem('lastVisitedPage', collectionUrl);
    } else {
      // If no collection in URL, save the product page
      sessionStorage.setItem('lastVisitedPage', document.referrer);
    }
  }
  
  // Update the link on the cart page
  if (window.location.pathname.includes('/cart')) {
    document.addEventListener('DOMContentLoaded', function() {
      const continueLink = document.getElementById('continue-shopping-link');
      
      if (continueLink) {
        const lastPage = sessionStorage.getItem('lastVisitedPage');
        
        // If there's a saved page, update the href
        if (lastPage) {
          continueLink.href = lastPage;
        }
        // Otherwise, use document.referrer as fallback
        else if (document.referrer && 
                 document.referrer.includes(window.location.hostname) &&
                 !document.referrer.includes('/cart')) {
          continueLink.href = document.referrer;
        }
        // Otherwise, the link is already set to routes.collections_url from HTML
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function myFunction() {
    var checkBox = document.getElementById("myCheck");
    var text = document.getElementById("text");
    if (checkBox.checked == true){
      text.style.display = "block";
    } else {
       text.style.display = "none";
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      if (window.swCompactProductRail) window.swCompactProductRail.mount(productRecommendationsSection);
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    if (window.swCompactProductRail) window.swCompactProductRail.unmount(event.target);
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
